import React, { useEffect, useState } from 'react'
import StudentSidebar from '../../StudentSidebar/StudentSidebar'
import { Link, useLocation, useNavigate } from 'react-router-dom'

import Checkout from './Checkout';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const StudentSessionPayment = () => {
    const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY;

    if (!STRIPE_KEY) {
        console.error("Stripe API key is missing!");
    }

    const stripePromise = loadStripe(STRIPE_KEY);
    const location = useLocation();
    const naivgate = useNavigate();
    const [clientSecret, setClientSecret] = useState("");

    useEffect(() => {
        if (location.state) {

            if (location.state.user) {
                setClientSecret(location.state.user.client_secret);
                console.log('client secret', clientSecret)
            }
            else {
                naivgate(-1)
            }
        }
        else {
            naivgate(-1)
        }

    }, [])





    return (
        <div className='student-session-payment'>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Group Batch Sessions
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            {stripePromise && clientSecret && (
                                <Elements stripe={stripePromise} options={{ clientSecret }}>
                                    <Checkout />
                                </Elements>
                            )}

                        </div>
                    </div>
                </div>
            </section>


        </div>
    )
}

export default StudentSessionPayment